
/**
 * Get level/floor for an element.
 * @param {DtModel} model Host model
 * @param {Number} dbId Element DB ID
 * @return {?Level}
 */
export function getLevelOfElement(model, dbId) {
    const data = model.getData();
    if (!data) return null;

    const levelId = data.dbId2levelId[dbId];
    if (levelId <= 0) return null;

    return model.getLevels()[levelId];
}

/**
 * Get unique consolidate level name of selection, or nothing.
 * @param {Array.<{model, selection}>} modelSelectionEntries Aggregate selection object.
 * @param {Boolean} [levelsOnly=false] if true, return the name only if all selections are levels
 * @return {?String}
 */
export function getConsolidatedLevelName(modelSelectionEntries, levelsOnly) {
    let levelName = null;

    for (const { model, selection: dbIds } of modelSelectionEntries) {
        const data = model.getData();
        if (!data) continue;

        const levelMap = model.getLevels();
        if (!levelMap) continue;

        const getLvlName = (dbId) => {
            const levelId = data.dbId2levelId && data.dbId2levelId[dbId];
            if (levelId > 0) return levelMap[levelId]?.name; /* Element is on a level */
            if (dbId in levelMap) return levelMap[dbId].name; /* Element is a level */
            return null
        }

        for (const dbId of dbIds) {
            if (levelsOnly && !levelMap[dbId]) return;

            const name = getLvlName(dbId);
            if (name == null) continue;
            if (levelName == null) {
                levelName = name;
                continue;
            }
            if (levelName !== name) {
                // More than one consolidated levels.
                return null;
            }
        }
    }

    return levelName;
}
